import {
    Typography,
} from '@material-ui/core';

export default function Paragraph({ description = '', variant = "body1", color = "primary", className = "" }) {
    return (
        <Typography variant={variant} color={color} className={className}>{description}</Typography>
    )
}